import { render } from "./UpdateStatusTag.vue?vue&type=template&id=9a5b5888&scoped=true"
import script from "./UpdateStatusTag.vue?vue&type=script&lang=js"
export * from "./UpdateStatusTag.vue?vue&type=script&lang=js"

import "./UpdateStatusTag.vue?vue&type=style&index=0&id=9a5b5888&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a5b5888"]])

export default __exports__